import styled from 'styled-components';

export const OptionContainer = styled.div<{ $isDisabled: boolean; $backgroundColor?: string }>`
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${({ $backgroundColor, theme }) => $backgroundColor || theme.colors['neutral-30']};
  padding: 4px 10px;
  border-radius: 6px;
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 12px;
  opacity: ${(props) => (props.$isDisabled ? 0.5 : 1)};
`;

export const DeleteButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  transition: all 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
  border-radius: 50%;
  width: 12px;
  height: 12px;

  &:hover {
    background: #ef5b5b;
    * {
      transition: all 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
      color: #fff;
    }
  }
`;
